<!-- 中间内容页，显示不同模块 -->
<template>
  <div>
    <div style="height: 75px;width: 100%">
      <ol class="area-list" v-for="(item, index) in index_nav">
        <li :class="localAreaId === item.content_page_id ? 'area_text' : 'area_text_non'"
            v-on:click="onItemClick(item.content_page_id)">
          {{ item.title }}
        </li>
      </ol>
    </div>
    <div v-for="(module, index) in moduleList">
      <!-- 轮播图 -->
      <!-- 直播 -->
      <class-section-live
        v-if="module.content_module_type===3"
        :module="module"
        :key="module.course_skip_category_id">
      </class-section-live>
      <!-- 课程 -->
      <class-section
        v-if="module.content_module_type===4"
        :module="module"
        :key="module.course_skip_category_id">
      </class-section>
    </div>
  </div>
</template>

<script>
import urls from '../../common/js/urls.js'
import IndexCarousel from "../Content/IndexCarousel"        //轮播图
import ClassSectionLive from "../Content/ClassSectionLive"  //近期直播
import ClassSection from "../Content/ClassSection"          //课程
import ClassSectionOffline from "../Content/ClassSectionOffline"   //线下班
import {api_content_operation_page} from "../../networks/ContentOperationHandler"
import {api_content_sy_page} from "../../networks/ContentOperationHandler"
import {api_content_page_nav} from "../../networks/ContentOperationHandler"

export default {
  // metaInfo: {
  //     title: '公考面试_公务员培训-必胜公考', // set a title
  //     meta: [
  //       {                 // set meta
  //         name: 'keywords',
  //         content: '公务员面试，公考面试，公务员面试培训'
  //       },
  //       {                 // set meta
  //         name: 'description',
  //         content: '必胜公考视频培训教程，在线免费试听，公务员考试面试培训班，面试系统课、面试备考指导、面试考情分析、面试礼仪及考试流程、面试专题突破，应有尽有，快点击了解'
  //       }
  //     ],
  //   },
  name: 'module',
  components: {
    IndexCarousel,   //轮播图
    ClassSectionLive,//近期直播
    ClassSection,    //课程
    ClassSectionOffline  //线下班
  },
  data() {
    return {
      index_nav: [],
      moduleList: [],
      localAreaId: 4,
    }
  },
  computed: {
    current_page_id() {
      return this.$route.params.page_id || this.$store.state.index_module_page_id;
    },
  },
  created: function () {
    var context = this;
    var domain = window.location.host;
    if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
      // if(domain=='localhost:8080'){
      var application_id = 300;
      context.$store.dispatch('update_application', application_id);
    }else{
      var application_id = 1;
      context.$store.dispatch('update_application', application_id);
    }
    var promise = api_content_page_nav(context);
    //2.更新返回数据
    promise.then(function(index_nav) {
      context.index_nav = index_nav;
      context.index_nav.shift();
      context.onItemClick(context.index_nav[0].content_page_id)
    }).catch(function(error){
        console.error(error);
    });
  },
  watch: {
    current_page_id: function (val) {
      this.initPage(this.current_page_id);
    },
  },
  methods: {
    initPage: function (page_id) {
      var context = this;
      var promise = api_content_operation_page(context, page_id);
      promise.then(function (r) {
        context.newPage(r["page_content"]);
      }).catch(function (error) {
      });
    },
    newPage: function (page_content) {
      var _this = this
      let index_page_id = this.$store.state.index_module_page_id;
      _this.moduleList = []; //模块列表
      if ($.isEmptyObject(page_content)) {
        return;
      }
      var modules = page_content.page.modules;
      for (var i = 0; i < modules.length; i++) {
        var module = modules[i];
        switch (module.content_module_type) {
          case 1: //轮播图
            _this.moduleList.push(module)
            break;
          case 3: // 直播课
            _this.moduleList.push(module)
            break;
          case 4: // 课程
            _this.moduleList.push(module)
            break;
          case 5: // 线下课程
            _this.moduleList.push(module)
            break;
          // case 6:
          //   _this.moduleList.push(module)
          //   break;
        }
      }
    },
    onItemClick: function (id) {
      let context = this;
      context.initPage(id)
      context.localAreaId = id
    },
  }
}
</script>

<style scoped>
.mt15 {
  margin-top: 15px;
}
</style>

<style>

.el-aside {
  color: #333;
  text-align: center;
}

.title {
  font-weight: normal;
  border-bottom: 1px #f2f2f2 solid;
}

.info_title {
  background-color: #ffffff;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info_title2 {
  background-color: #f8f8f8;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: row;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.area-list {
  float: left;
  padding: 0;
  margin-top: 45px;
  list-style: none;
}

.area_text_non {
  min-width: 75px;
  text-align: center;
  color: #999999;
}

.area_text {
  min-width: 75px;
  font-weight: bold;
  text-align: center;
  color: #ffbc42;
}



</style>



// WEBPACK FOOTER //
// src/components/Layout/coursePage.vue